// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2c63y","footer":"styles_footer__32JMS"};